import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

shippingAddressStyles.container = {
    gap: 20,
    css: css`
        > div[class^="GridOffset"] {
            > div:first-child[class^="GridItemStyle"] {
                flex-basis: 100%;
                max-width: 100%;
            }
            > div[class^="GridItemStyle"] {
                &:nth-child(2) {
                    flex-basis: 100%;
                    max-width: 100%;
                }
            }
        }
    `,
};

shippingAddressStyles.headingGridItem = {
    width: 6,
    css: css`
        align-items: center;
        > h3[class^="TypographyStyle"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 15px;
                        `,
                        css`
                            font-size: 15px;
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};

shippingAddressStyles.oneTimeAddressGridItem = {
    width: 6,
};
